import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import Widget from './Widget';
import './index.css';

// Check if we're in widget mode (no root element)
const rootElement = document.getElementById('root');

if (rootElement) {
  // Normal app mode
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  // Widget mode - make sure Widget is available
  console.log('Running in widget mode');
}

// Always make Widget available globally
window.ChatWidget = Widget;

// Import Widget to make it available globally when bundled
// Esto carga el widget si se usa en modo standalone
import('./Widget').catch(err => {
  console.warn("Widget no cargado (modo normal):", err);
});

// Optional: report web vitals
// import reportWebVitals from './reportWebVitals';
// reportWebVitals(console.log);